import { useQuery } from '@tanstack/react-query';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { URLS } from 'utils/tests/urls.config';
import { lendingApiFetchJson } from './lendingApi';

const getApplicationsUrl = (
  introducerId: string,
  search?: string,
  dateFrom?: string | null,
  includePartnerChannel?: boolean,
) =>
  URLS.applications({
    introducerId,
    query: {
      search,
      date_from: dateFrom,
      include_partner_channel: includePartnerChannel,
    },
  });

async function lendingAPIGetApplications(
  introducerId: string,
  dateFrom?: string | null,
  search?: string,
  includePartnerChannel?: boolean,
) {
  const response = await lendingApiFetchJson(
    getApplicationsUrl(introducerId, search, dateFrom, includePartnerChannel),
  );
  return response;
}

export const useGetApplications = (
  search?: string,
  dateFrom?: string | null,
  includePartnerChannel?: boolean,
) => {
  const { introducerId } = useIntroducerData();
  return useQuery({
    queryKey: [
      'applications',
      introducerId,
      dateFrom,
      search,
      includePartnerChannel,
    ],
    queryFn: () =>
      lendingAPIGetApplications(
        introducerId as string,
        dateFrom,
        search,
        includePartnerChannel,
      ),
    enabled: !!introducerId,
  });
};
